/**************************************************
 * Nombre:       Seccion_Escuela_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Escuela_Detalle_Portada from "./Componentes/Escuela_Detalle_Portada";
import Escuelas_QueProgramas from "./Componentes/Escuelas_QueProgramas";
import Escuela_Beneficios from "./Componentes/Escuela_Beneficios";
import Escuela_Comunidad from "./Componentes/Escuela_Comunidad";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";


const Seccion_Escuela_Detalle = () => {

    useEffect(() =>{
       irArriba()
    },[])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Escuela_Detalle_Portada/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Escuelas_QueProgramas/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 18}}>
                <Escuela_Beneficios/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 18}}>
                <Escuela_Comunidad/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 20}}>
                <Home_Testimonios/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Escuela_Detalle